import L from 'leaflet';
import "leaflet.vectorgrid";

import { useState, useEffect } from 'react';
import useTranslation from '../../../Language/useTranslation';

var core = require("@react-leaflet/core");




function createMVT(props: any, context: any) {
    const instance = L.vectorGrid.protobuf(props.url, props.options);
    return {
        instance: instance,
        context: { ...context, overlayContainer: instance },
    };
}

function updateMVT(instance: any, props: any, prevProps: any) {


}

const TileSchadflaechenComponent = core.createPathComponent(createMVT, updateMVT);

export function SchadflaechenLayer(props: any) {

    const t = useTranslation()



    const schadflaechenStyles = {
        Bundeslaender_Waldzustand: function (properties: any, zoom: any) {
            return {
                // Stroke properties
                stroke: true,
                color: "white",
                weight: 0.3,
            };
        },
    };

    return (
        <TileSchadflaechenComponent
            url={t.layersSchadflaechen[0].url}
            options={{
                rendererFactory: L.canvas.tile,
                vectorTileLayerStyles: schadflaechenStyles,
                // interactive: true,
                zIndex: 100,
                // minZoom: config.mapSettings.minZoom,
                // maxZoom: config.mapSettings.maxZoom,
                // maxNativeZoom: config.mapSettings.nativeZoom
            }}

        >

        </TileSchadflaechenComponent>

    );


}